const SPECKS = [
  { top: "-7%", left: "9%", size: 8, color: "#22C55E", glow: "rgba(34,197,94,0.55)", delay: "0s" },
  { top: "10%", right: "-4%", size: 6, color: "#FACC15", glow: "rgba(250,204,21,0.55)", delay: "1.2s" },
  { top: "42%", left: "-5%", size: 7, color: "#16A34A", glow: "rgba(22,163,74,0.5)", delay: "2.1s" },
  { bottom: "14%", right: "-3%", size: 9, color: "#22C55E", glow: "rgba(34,197,94,0.5)", delay: "0.7s" },
  { bottom: "-6%", left: "32%", size: 6, color: "#FACC15", glow: "rgba(250,204,21,0.5)", delay: "1.7s" },
  { top: "26%", right: "12%", size: 5, color: "#4ADE80", glow: "rgba(74,222,128,0.5)", delay: "2.8s" },
];

const GlowSpecks = () => (
  <div aria-hidden="true" className="pointer-events-none absolute inset-0">
    {SPECKS.map((s, i) => (
      <span
        key={i}
        className="glow-speck"
        style={{
          top: s.top,
          left: s.left,
          right: s.right,
          bottom: s.bottom,
          width: s.size,
          height: s.size,
          background: s.color,
          boxShadow: `0 0 12px 2px ${s.glow}`,
          animationDelay: s.delay,
        }}
      />
    ))}
  </div>
);

export default GlowSpecks;
